import React, { useEffect, useState } from 'react';
import { Button } from 'reactstrap';

//Constants
import { actionsTable } from '../../../../constants/MaterialTable';

//API 
import perfil_api from '../../../../api/perfil_api';

//Helpers
import { showMessage } from '../../../../helpers/message';

//Context 
import { useAuth } from '../../../../context/auth';

//Componentes
import TabelaListagem from '../../../../components/TabelaListagem/TabelaListagem';
import PerfilStepper from './components/PerfilStepper';


function Perfil({ permissoes }) {
    const { setLoading } = useAuth();

    //State para pegar os perfil dos usuarios
    const [listPerfil, setListPerfil] = useState([]);

    //State para Editar o perfil dos usuario
    const [perfil_id, setPerfil_id] = useState(null);

    //State para pegar os perfil dos usuario
    const [perfilNovo, setPerfilNovo] = useState(false);

    //Variavel de controle de edição da tela
    const editavel = permissoes.filter(permissao => permissao.acao == "Editar").length > 0;

    //Fução para editar perfil
    const editar = (rowData) => {
        setPerfil_id(rowData.id);
    }

    const visualizar = (rowData) => {
        setPerfil_id(rowData.id);
    }

    //Ações que a tabela
    const actions = [
        ...editavel
         ? [actionsTable.editar(editar)]
         : [actionsTable.visualizar(visualizar)]
    ];

    //Cabeçalhos que a tabela terá
    const headers = [
        { value: "Identificação", objectValue: "identificacao", align: "left" },
        { value: "Status", objectValue: "status", align: "left" }
    ];

    //Função que carrega a lista de perfis
    const loadPerfil = () => {
        setLoading(true);
        perfil_api.getList().then(response => {
            setListPerfil(response.data);
        })
            .catch(e => showMessage("Erro", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    useEffect(() => {
        loadPerfil();
    }, []);

    const handleVoltar = () => {
        setPerfil_id(null);
        setPerfilNovo(false);
        loadPerfil();
    }

    if (perfilNovo || perfil_id) {
        return <PerfilStepper
            id={perfil_id}
            handleVoltar={handleVoltar}
            editavel={editavel}
        />
    }

    return <>
        <div className={`d-flex align-items-center justify-content-between mb-4 ${editavel ? "" : "d-none"}`}>
            <h4 className='text-secondary m-0'>Perfis</h4>
            {editavel && <Button color='success' onClick={() => { setPerfilNovo(true) }}>+ Cadastrar</Button>}
        </div >
        <TabelaListagem
            actions={actions}
            title={"Lista de Perfis"}
            options={{ print: false, search: true, pagination: true }}
            headers={headers}
            items={listPerfil}
        />
    </>
}

export default Perfil;